import { render } from "./InfoPolicies.vue?vue&type=template&id=395cf67e&scoped=true"
const script = {}

import "./InfoPolicies.vue?vue&type=style&index=0&id=395cf67e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395cf67e"]])

export default __exports__